// extracted by mini-css-extract-plugin
export var active = "Tag-module--active--e0433";
export var arrow = "Tag-module--arrow--411fe";
export var arrowNo = "Tag-module--arrow_no--64898";
export var arrowYes = "Tag-module--arrow_yes--b360c";
export var big = "Tag-module--big--8d46a";
export var bordered = "Tag-module--bordered--e69d9";
export var disabled = "Tag-module--disabled--7ab94";
export var flex = "Tag-module--flex--a084f";
export var flex1 = "Tag-module--flex_1--5cf08";
export var flexCenter = "Tag-module--flex_center--82e2a";
export var flexCenterCol = "Tag-module--flex_center_col--2cb56";
export var flexCol = "Tag-module--flex_col--4d9d1";
export var flexFixCenterCol = "Tag-module--flex_fix_center_col--0bc10";
export var flexFixedCenterCol = "Tag-module--flex_fixed_center_col--20892";
export var medium = "Tag-module--medium--46818";
export var paddingWrapper = "Tag-module--paddingWrapper--5f859";
export var rotating = "Tag-module--rotating--54a27";
export var rounded = "Tag-module--rounded--5a5ff";
export var small = "Tag-module--small--39091";
export var tag = "Tag-module--tag--c952d";